<template>
<div class="product-detail">
	<div class="product-detail-container w">
		<div class="product-detail-title">
			{{ productType(productData.goodsCategory) }}详情页面<span>Details Page</span>
		</div>
		<div class="product-detail-row">
			<div class="product-detail-left" v-if="productData.goodsThumbnail">
				<!-- <el-image :src="productData.goodsThumbnail"></el-image> -->
				<img :src="productData.goodsThumbnail"/>
				<div class="product-detail-left-box">
					<div class="product-detail-left-name" :title="productData.goodsName">
						{{ productData.goodsName }}</div>
					<el-divider></el-divider>
					<div class="product-detail-left-desc">
						{{ productData.goodsDescribe }}
					</div>
					<div class="product-detail-left-price">
						{{ computeProductPrice(productData.goodsPriceType, productData.goodsPrice) }}</div>
					<div class="product-detail-left-operate">
						<el-button type="primary" @click="buyProduct">
							立刻购买<i class="el-icon-check"></i></el-button>
						<el-button type="primary" plain @click="addShoppingCart">
							加入购物车<i class="el-icon-plus"></i></el-button>
					</div>
					<div class="product-detail-left-other">
						<div class="product-detail-left-item" @click="collectProduct"
							style="cursor: pointer;" v-if="!isCollected">
							<i class="el-icon-star-off"></i>
							收藏<span>({{ otherData.goodsCollectNum }})</span>
						</div>
						<div class="product-detail-left-item" @click="uncollectProduct"
							style="cursor: pointer;" v-else>
							<i class="el-icon-star-on"></i>
							已收藏<span>({{ otherData.goodsCollectNum }})</span>
						</div>
						<div class="product-detail-left-item">
							浏览<span>({{ otherData.goodsReadNum }})</span>
						</div>
						<div class="product-detail-left-item">
							购买<span>({{ otherData.goodsSaleNum }})</span>
						</div>
					</div>
				</div>
			</div>
			<div class="product-detail-right">
				<div class="product-company-top">
					<el-image :src="shopData.shopLogo" fit="cover" @click="toCompany"></el-image>
					<el-button type="primary" v-if="!shopData.shopIsFocus"
						@click="subscribeStore">订阅店铺</el-button>
					<el-button type="primary" v-else plain @click="cancelSubscribeStore">
						<i class="el-icon-check"></i>已订阅</el-button>
				</div>
				<div class="product-company-content">
					<div class="product-company-content-item">
						<i class="el-icon-office-building"></i>
						<div class="product-company-content-item-info">
							<div>服务商</div>
							<span @click="toCompany" style="cursor: pointer;">{{ shopData.shopName }}</span>
						</div>
					</div>
					<div class="product-company-content-item">
						<i class="el-icon-phone"></i>
						<div class="product-company-content-item-info">
							<div>服务热线</div>
							<span>{{ shopData.serviceHotline }}</span>
						</div>
					</div>
					<div class="product-company-content-item">
						<i class="el-icon-time"></i>
						<div class="product-company-content-item-info">
							<div>服务时间</div>
							<span>{{ shopData.serviceBeginTime + '~' + shopData.serviceEndTime }}</span>
							<br>
							<span>{{ '(' + shopData.serviceDate + ')' }}</span>
						</div>
					</div>
					<div class="product-company-content-item">
						<i class="el-icon-message"></i>
						<div class="product-company-content-item-info">
							<div>电子邮件</div>
							<span>{{ shopData.shopEmail }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="product-detail-row">
			<div class="product-detail-left" style="flex-direction: column;">
				<div class="product-detail-box-title">
					{{ productType(productData.goodsCategory) }}详情</div>
				<div class="product-detail-describe-content" v-html="productDesc"></div>
			</div>
			<div class="product-detail-right">
				<div class="product-detail-box-title">相关推荐</div>
				<div class="product-detail-recommend">
					<div class="product-recommend-item" v-for="item in recommendData" @click="toOtherProduct(item.goodsId)">
						<el-image :src="item.goodsThumbnail"></el-image>
						<div class="product-recommend-item-info">
							<div class="product-recommend-item-name" :title="item.goodsName">{{ item.goodsName }}</div>
							<div class="product-recommend-item-price">
								{{ computeProductPrice(item.goodsPriceType, item.goodsPrice) }}
							</div>
						</div>
					</div>
					<div class="product-no-data" v-if="!recommendData.length">
						暂无推荐数据</div>
				</div>
			</div>
		</div>
		<div class="product-detail-row" style="margin-bottom: 0;">
			<div class="product-detail-left" style="flex-direction: column;">
				<div class="product-detail-box-title">用户评价</div>
				<div class="product-detail-comment-box">
					<div class="product-detail-comment-item" v-for="item in commentData">
						<div class="product-comment-user">
							<el-image :src="item.pic"></el-image>
							<div>{{ item.userName }}</div>
						</div>
						<div class="product-comment-info">
							<el-rate :value="item.evaluate" disabled></el-rate>
							<div class="product-comment-text">{{ item.content }}</div>
							<div class="product-comment-date">{{ item.commentTime }}</div>
						</div>
					</div>
					<div class="product-no-data" v-if="!commentData.length">
						暂无用户评价</div>
					<el-pagination layout="total, prev, pager, next" :total="commentCount" background
						:current-page.sync="commentPage" @current-change="getComment"></el-pagination>
				</div>
			</div>
		</div>
	</div>

	<!-- 加入购物车动画 -->
	<Transition appear @before-appear="initialStatus" @enter="runStatus" :key="index"
		@after-appear="displayStatus" v-for="(item, index) in movingBall">
		<div class="product-thumb" v-if="item" :style="{top: topBall + 'px', left: leftBall + 'px'}">
			<img :src="ballImg" />
		</div>
	</Transition>
</div>
</template>

<script>
export default {
	name: 'ProductDetail',
	data() {
		return {
			userID: '',
			productId: this.$route.params.id,
			productData: {},
			productDesc: {},
			isCollected: false,
			companyData: {},
			shopData: {},
			otherData: {},
			recommendData: [],
			commentData: [],
			commentPage: 1,
			commentCount: 0,

			leftBall: 0,
			topBall: 0,
			movingBall: [],
			ballImg: null
		}
	},
	mounted() {
		var that=this;
		setTimeout(function(){
			that.userID=that.$store.state.user.userInfo.id
		console.log(1312312312,that.userID,that.$store.state.user.userInfo);
		that.getProductDetail()
		that.getProductCollect()

		that.getProductDesc()
		that.getShopInfo()
		that.getOtherData()
		that.getRecommend()
		that.getComment()
		},300)
		
	},
	computed: {
		productType() {
			return (type) => {
				if(type === 1) {
					return '影像数据'
				}else if(type === 2) {
					return '数据产品'
				}else if(type === 3) {
					return '软件产品'
				}else if(type === 4) {
					return '其他产品'
				}
			}
		},
		computeProductPrice() {
			return (type, price) => {
				if(type === 1) {
					return '￥'+ Number(price).toFixed(2)
				}else if(type === 2) {
					return '面议'
				}else if(type === 3) {
					return '免费'
				}else {
					return '获取价格失败'
				}
			}
		}
	},
	methods: {
		getProductDetail() {
			// 获取商品信息
			// this.$http.get(this.$const.RemoteSensingMall.requestProductDetail + this.productId)
			// .then(res => {
			// 	console.log('1', res)
			// 	if(res.code === 200) {
			// 		this.productData = res.data.goodsInfo
			// 	}
			// }).catch(error => {
			// 	console.log(error)
			// })
		},
		getProductDesc() {
			// 获取商品信息 - 带详情
			this.$http.get(this.$const.common.getShopGoodsDesc + this.productId).then(res => {
				// console.log(res)
				if(res.code === 200) {
					this.productData = res.data.goodsInfo
					if(res.data.goodsExtension) {
						this.productDesc = res.data.goodsExtension.goodsProductIntroduction	
					}else {
						this.productDesc = '暂无商品详情介绍'
					}
				}
			})
		},
		getShopInfo() {
			// 获取店铺信息
			this.$http.post(this.$const.RemoteSensingMall.IDshopGet, {
				goodsId: this.productId,
				userId: this.userID
			}).then((res) => {
				if(res.code === 200) {
					this.shopData = res.data;
				}
			})
		},
		getProductCollect() {
			// 用户是否收藏
			if(this.userID) {
				this.$http.post(this.$const.RemoteSensingMall.collectwhether, {
					userId: this.userID,
					collectGoodsId: this.productId
				}).then(res => {
					if(res.code === 200) {
						this.isCollected = res.data
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		getOtherData() {
			// 获取收藏、浏览和购买信息
			this.$http.get(this.$const.RemoteSensingMall.requestProductCounts + this.productId)
			.then(res => {
				if(res.code === 200) {
					this.otherData = res.data
				}
			}).catch(error => {
				console.log(error)
			})
		},
		getRecommend() {
			// 推荐商品
			this.$http.get(this.$const.RemoteSensingMall.goodsRecommend + this.productId).then(res => {
				console.log(res)
				if(res.code === 200) {
					this.recommendData = res.data
				}
			}).catch(error => {
				console.log(error)
			})
		},
		getComment() {
			// 用户评价
			this.$http.post(this.$const.common.commentgetComment, {
				goodsId: this.productId,
				pageNum: this.commentPage,
				pageSize: 12
			}).then(res => {
				if(res.code === 200) {
					this.commentCount = res.data.total
					this.commentData = res.data.list
				}
			}).catch(error => {
				console.log(error)
			})
		},
		isLogin() {
			if(this.userID) {
				return true
			}else {
				this.$message.warning('请先登录');
				return false
			}
		},
		buyProduct() {
			// 创建订单
			if(this.isLogin()) {
				this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder, {
					buyType: 1,
					itemParams: [{
						goodsId: this.productId,
						number: 1
					}]
				}).then(res => {
					if(res.code === 200 && res.data) {
						this.$router.push({path: '/confirmPay', query: {N: res.data}})
					}else {
						this.$message.error(this.$PubText.getInfoFail);
					}
				}).catch(error => {
					console.log(error)
					this.$message.error(this.$PubText.InterfaceFail);
				})
			}
		},
		addShoppingCart(el) {
			// 加入购物车
			if(this.isLogin()) {
				this.$http.post(this.$const.RemoteSensingMall.shoppingCartaddItem, [{
					goodsId: this.productId,
					number: 1
				}]).then(res => {
					if(res.code === 200 && res.data == "添加成功") {
						this.$store.dispatch("shoppingCart/getCartINFO", {})

						this.movingBall = [...this.movingBall, true]
						this.ballImg = this.productData.goodsThumbnail
						this.topBall = el.target.getBoundingClientRect().top
						this.leftBall = el.target.getBoundingClientRect().left
					}else {
						this.$message.error(this.$PubText.getInfoFail)
					}
				}).catch(error => {
					console.log(error)
					this.$message.error(this.$PubText.InterfaceFail)
				})
			}
		},
		collectProduct() {
			// 收藏商品
			if(this.isLogin()) {
				this.$http.post(this.$const.RemoteSensingMall.collectadd, {
					userId: this.userID,
					collectGoodsId: this.productId
				}).then(res => {
					if(res.code === 200 && res.data.collectTime) {
						this.isCollected = true
						this.otherData.goodsCollectNum += 1
						this.$message.success('收藏成功！')
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		uncollectProduct() {
			// 取消收藏
			if(this.isLogin()) {
				this.$http.delete(this.$const.RemoteSensingMall.collectdel, {
					goodsId: this.productId
				}).then(res => {
					if(res.code === 200 && res.data) {
						this.isCollected = false
						this.otherData.goodsCollectNum -= 1
						this.$message.success('成功取消！')
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		subscribeStore() {
			// 订阅店铺
			if(this.isLogin()) {
				this.$http.post(this.$const.RemoteSensingMall.focusSaveAdd, {
					userId: this.userID,
					focusShopInfoId: this.productData.shopId
				}).then(res => {
					if(res.code === 200 && res.data) {
						this.$message.success('订阅成功')
						this.shopData.shopIsFocus = true
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		cancelSubscribeStore(){
			// 取消订阅店铺
			if(this.isLogin()) {
				this.$http.delete(this.$const.RemoteSensingMall.focusSaveDel, {
					shopId: this.productData.shopId
				}).then(res => {
					if(res.code === 200 && res.data) {
						this.$message.success('取消成功')
						this.shopData.shopIsFocus = false
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		toCompany() {
			this.$router.push({path: "/companyInfo", query: { goodsId: this.productId}})
		},
		toOtherProduct(id) {
			window.open('/#/productDetail/' + id, '_blank')
			// this.$router.push({ name: "productDetail", params: { id: id}})
		},
		initialStatus(el) {
			el.style.opacity = 0
			el.style.transform = 'translate(0, 0)'
		},
		runStatus(el, done) {
			let chartSite = document.getElementById('shopCart').getBoundingClientRect()
			const xDis = chartSite.left - this.leftBall + 10
			const yDis = chartSite.top - this.topBall
			el.style.transform = `translate(${xDis}px, ${yDis}px)`
			if (this.topBall > 350) {
				el.style.transition = 'all 0.8s cubic-bezier(0.12,0.78,0.53,0.92)';
			} else if (this.topBall > 150) {
				el.style.transition = 'all 1.5s cubic-bezier(0.12,0.78,0.53,0.92)';
			}
			this.movingBall = this.movingBall.map(item => false)
			done()
		},
		displayStatus(el) {
			el.style.opacity = 1
		}
	}
}
</script>

<style lang="scss" scoped>
.product-detail {
	background-color: #F5F5F5;

	>.product-detail-container {
		padding-bottom: 60px;

		>.product-detail-title {
			padding: 30px 0;
			color: #2569F2;
			font-size: 24px;
			font-weight: 700;
			letter-spacing: 2px;

			>span {
				margin-left: 20px;
				color: #798AAC;
				font-size: 16px;
			}
		}

		>.product-detail-row {
			display: flex;
			flex-direction: row;
			margin-bottom: 20px;

			.product-detail-box-title {
				margin-top: 10px;
				font-size: 20px;
				font-weight: 700;

				&::before {
					content: '';
					display: inline-block;
					margin-right: 20px;
					width: 5px;
					height: 22px;
					vertical-align: bottom;
					background-color: #2569F2;
				}
			}

			>.product-detail-left {
				flex: 3;
				display: flex;
				padding: 20px;
				background-color: white;
				border-radius: 6px;

				> .el-image, > img {
					width: 540px;
					height: 300px;
					border-radius: 6px;
				}
				> .product-detail-left-box{
					margin-left: 30px;
					
					> .el-divider {
						margin-top: 20px;
						margin-bottom: 10px;
						width: 50px;
						height: 2px;
						background-color: #2569F2;
					}
					> .product-detail-left-name{
						width: 400px;
						font-size: 24px;
						font-weight: 700;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
					}
					> .product-detail-left-desc{
						width: 400px;
						max-height: 90px;
						color: #333333;
						font-size: 16px;
						overflow: auto;
					}
					> .product-detail-left-price {
						margin-top: 20px;
						margin-bottom: 10px;
						color: #B11A1A;
						font-size: 28px;
						font-weight: 700;
					}
					> .product-detail-left-operate{
						display: flex;
						justify-content: space-around;

						> button {

							i {
								margin-left: 50px;
							}
						}
					}
					> .product-detail-left-other{
						display: flex;
						align-items: center;
						justify-content: space-around;
						margin-top: 8px;

						> .product-detail-left-item{
							display: flex;
							flex-direction: row;
							align-items: center;
							color: #999999;
							font-size: 14px;

							> i {
								margin-right: 10px;
								color: #2569F2;
								transition: .2s;
							}
							> span {
								margin-left: 10px;
								color: #999999;
							}
						}
					}
				}
				> .product-detail-describe-content{
					margin: 0 auto;
					margin-top: 30px;
					max-width: 920px !important;
					max-height: 1200px;
					overflow: auto;
					overflow-x: hidden;
				}
				> .product-detail-comment-box{
					margin: 20px;
					margin-bottom: 0;

					> .product-detail-comment-item{
						display: flex;
						flex-direction: row;
						align-items: flex-start;
						margin-top: 20px;

						> .product-comment-user {
							// flex: 1;
							display: flex;
							align-items: center;
							width: 180px;

							> .el-image {
								width: 32px;
								height: 32px;
								margin-right: 20px;
								border-radius: 50%;
							}
							> div:last-child{
								font-size: 16px;
							}
						}
						> .product-comment-info{
							flex: 1;
							display: flex;
							flex-direction: column;
							margin-left: 60px;
							padding-bottom: 20px;
							border-bottom: 1px solid #EEEEEE;

							&:last-child {
								border-bottom: none;
							}

							> .product-comment-text {
								margin: 20px 0;
								font-weight: 600;
							}
							> .product-comment-date {
								color: #999999;
								font-size: 16px;
							}
						}
					}
					> ::v-deep .el-pagination {
						margin: 60px 0;

						> button, > ul li {
							border-radius: 6px;
						}
					}
				}
			}

			> .product-detail-right{
				flex: 1;
				margin-left: 10px;
				padding: 20px;
				background-color: white;
				border-radius: 6px;

				> .product-company-top{
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 12px;

					> .el-image {
						width: 100px;
						height: 100px;
						cursor: pointer;
					}
					> button {
						i {
							margin-right: 8px;
						}
					}
				}
				> .product-company-content{

					> .product-company-content-item {
						display: flex;
						flex-direction: row;
						align-items: center;
						padding-top: 10px;

						&:last-child {

							> .product-company-content-item-info {
								border-bottom: none;
							}
						}
						> i {
							margin-right: 20px;
							color: #999999;
							font-size: 16px;
						}
						> .product-company-content-item-info {
							flex: 1;
							padding-bottom: 9px;
							border-bottom: 1px solid #EEEEEE;
							
							> div {
								color: #999999;
								font-size: 14px;
							}
						}
					}
				}
				> .product-detail-recommend{
					margin-top: 10px;

					> .product-recommend-item {
						display: flex;
						flex-direction: row;
						align-items: center;
						padding: 20px;
						border-bottom: 1px solid #EEEEEE;
						transition: .3s;
						cursor: pointer;

						&:last-child {
							border-bottom: none;
						}
						&:hover {
							background-color: #F5F5F5;
						}

						> .el-image {
							width: 80px;
							height: 80px;
							margin-right: 20px;
							border-radius: 6px;
						}
						> .product-recommend-item-info{
							flex: 1;

							> .product-recommend-item-name {
								width: 180px;
								margin-bottom: 12px;
								font-weight: 700;
								white-space: nowrap;
								text-overflow: ellipsis;
								overflow: hidden;
							}
							> .product-recommend-item-price{
								color: #BD4444;
								font-size: 18px;
								font-weight: 600;
							}
						}
					}
				}
			}
		}
		.product-no-data{
			margin-top: 24px;
			color: #999999;
			font-size: 14px;
			text-align: center;
		}
	}
	> .product-thumb {
		position: fixed;
		z-index: 9;

		> img {
			width: 100px;
			height: 100px;
			border-radius: 50%;
			animation: .8s moveToCart ease-in-out;
		}
	}
	@keyframes moveToCart {
		from {
			transform: scale(1);
		}
		to {
			transform: scale(.2);
		}
	}
}
</style>